module.exports = __webpack_public_path__ + "static/media/hero-9.388464d3.jpg";